import {lazy, Suspense} from 'react'
import {createRoutesFromElements, Route} from 'react-router'
import {MainErrorBoundary} from 'components/MainErrorBoundary'
import {Spinner} from 'elements/Spinner'

const ExternalRouter = lazy(() =>
  import('./external/router').then(({ExternalRouter}) => ({
    default: ExternalRouter,
  }))
)
const MainRouter = lazy(() =>
  import('./main/router').then(({MainRouter}) => ({default: MainRouter}))
)

export const rootRouter = createRoutesFromElements(
  <Route errorElement={<MainErrorBoundary />}>
    <Route
      path='/app/*'
      element={
        <Suspense fallback={<Spinner />}>
          <ExternalRouter />
        </Suspense>
      }
    />
    <Route
      path='*'
      element={
        <Suspense fallback={<Spinner />}>
          <MainRouter />
        </Suspense>
      }
    />
  </Route>
)
